import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

export default class extends Controller {
  static targets = [
    'select',
    'companyName',
    'companyTin',
    'companyNameBlock',
    'companyTinBlock',
    'intracommunityVatNumberBlock',
    'intracommunityVatNumber',
    'fiscalCountry',
    'invoiceAddressLabel',
    'invoiceCountry',
    'identificationNumberBlock',
    'identificationNumber',
  ];

  static values = {
    clubCountry: String,
    euCountries: Array,
  };

  connect() {
    function forwardSelectChange() {
      const event = new Event('change', { bubbles: true });
      this.dispatchEvent(event);
    }

    $(this.selectTarget).on('select2:select select2:unselect', forwardSelectChange);
    $(this.fiscalCountryTarget).on('select2:select select2:unselect', forwardSelectChange);
    $(this.invoiceCountryTarget).on(
      'select2:select select2:unselect change.select2',
      forwardSelectChange
    );

    this.update();
  }

  update() {
    this.updateDisplayedFields();
    this.updateInvoiceAddressLabel();
  }

  updateDisplayedFields() {
    const fiscalCountryInEu = this.euCountriesValue.includes(this.fiscalCountryTarget.value);
    const invoiceCountryInEu = this.euCountriesValue.includes(this.invoiceCountryTarget.value);
    const displayIntraCommunityVatNumber =
      this.selectTarget.value === 'company' &&
      this.clubCountryValue !== this.fiscalCountryTarget.value &&
      fiscalCountryInEu;
    const displayCompanyTin =
      this.selectTarget.value === 'company' && !displayIntraCommunityVatNumber;

    if (this.selectTarget.value === 'individual' && invoiceCountryInEu) {
      this.showIdentificationNumber();
    } else {
      this.hideIdentificationNumber();
    }

    if (this.selectTarget.value === 'company' && displayIntraCommunityVatNumber) {
      this.showCompanyName();
      this.showIntraCommunityVatNumber();
    } else if (displayCompanyTin) {
      this.showCompanyName();
      this.showCompanyTin();
    } else {
      this.hideCompanyName();
    }
  }

  showIdentificationNumber() {
    if (this.hasIdentificationNumberBlockTarget) {
      this.identificationNumberBlockTarget.classList.remove('d-none');
      this.identificationNumberTarget.setAttribute('required', '');
    }
  }

  hideIdentificationNumber() {
    if (this.hasIdentificationNumberBlockTarget) {
      this.identificationNumberBlockTarget.classList.add('d-none');
      this.identificationNumberTarget.removeAttribute('required');
    }
  }

  updateInvoiceAddressLabel() {
    const { companyAddress, individualAddress } =
      this.invoiceAddressLabelTarget.dataset;

    const translation =
      this.selectTarget.value === 'company' ? companyAddress : individualAddress;

    this.invoiceAddressLabelTarget.textContent = translation;
  }

  showCompanyName() {
    this.companyNameBlockTarget.classList.remove('d-none');
    this.companyNameTarget.setAttribute('required', '');
  }

  showIntraCommunityVatNumber() {
    this.intracommunityVatNumberBlockTarget.classList.remove('d-none');
    this.intracommunityVatNumberTarget.setAttribute('required', '');
    this.hideCompanyTin();
  }

  showCompanyTin() {
    this.companyTinBlockTarget.classList.remove('d-none');
    this.companyTinTarget.setAttribute('required', '');
    this.hideIntracommunityVatNumber();
  }

  hideCompanyName() {
    this.companyNameBlockTarget.classList.add('d-none');
    this.companyNameTarget.removeAttribute('required');
    this.hideIntracommunityVatNumber();
    this.hideCompanyTin();
  }

  hideCompanyTin() {
    this.companyTinBlockTarget.classList.add('d-none');
    this.companyTinTarget.removeAttribute('required');
  }

  hideIntracommunityVatNumber() {
    this.intracommunityVatNumberBlockTarget.classList.add('d-none');
    this.intracommunityVatNumberTarget.removeAttribute('required');
  }
}
